import React from "react";

class BkBasePage extends React.Component {

	_isMounted = false;


	setState(state, callback) {
		if(!this._isMounted){
			console.error(" page _isMounted = false ;; " + JSON.stringify(state));
			return;
		}
		super.setState(state, callback);
	}


	componentDidMount() {
		this._isMounted = true;
		//console.log(this.props.location.pathname + ' search=' + queryString.extract(this.props.location.search));
	}

	componentWillUnmount() {
		this._isMounted = false;
	}
}


export default BkBasePage;
// export default withRouter(BkBasePage);